var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"font-size":"14px","color":"#0b58a2"}},[_vm._v("Is App")])
}
var staticRenderFns = []

export { render, staticRenderFns }